<div class="custom-date-wrapper relative flex no-global-input w-full">
  <img
    [src]="assetUrl + 'icons/calendar.svg'"
    class="h-5 w-5 ml-4 pointer-events-none absolute left-0 top-3"
    alt=""
  />

  <input
    ngbDatepicker
    #d="ngbDatepicker"
    [(ngModel)]="model"
    (dateSelect)="onDateSelected($event)"
    placeholder="Pick a date"
    class="custom-date-input text-sm text-[#181D27]"
    (click)="d.toggle()"
  />
</div>
